import { apiClient } from './client.tsx';
import type { Staff } from '../models/staff.ts';

export const fetchStaffInfo = () =>
  apiClient.get<{ data: Staff }>('/v2/staffs/info').then((res) => res.data);
